export default "__VITE_ASSET__DuXq0mpK__"